import { Action } from "@ngrx/store";
import { ResearchGridBase } from "../models/research-grid-page.model";
import { GetResearchDocsParams } from "src/app/store/models/research-grid-page.model";
export const SET_RESEARCH_BASE = "SET_RESEARCH_BASE";
export const CHANGE_FILTER = "CHANGE_FILTER";
export const CHANGE_DATE_FILTER = "CHANGE_DATE_FILTER";
export const RESET_FILTER = "RESET_FILTER";

export class SetResearchBase implements Action {
  readonly type = SET_RESEARCH_BASE;
  constructor(public payload: ResearchGridBase) {}
}

export class ChangeFilter implements Action {
  readonly type = CHANGE_FILTER;
  constructor(public payload: GetResearchDocsParams | {}) {}
}
export class ChangeDateFilter implements Action {
  readonly type = CHANGE_DATE_FILTER;
  constructor(public payload) {}
}
export class ResetFilter implements Action {
  readonly type = RESET_FILTER;
  constructor(public payload: GetResearchDocsParams | {}) {}
}

export type Actions =
  | SetResearchBase
  | ChangeFilter
  | ResetFilter
  | ChangeDateFilter;
